import { StorageInterface } from "../StorageInterface";

class SessionStorageDriver implements StorageInterface {

  public getInstant(key): string {
    return sessionStorage.getItem(key);
  }

  public get(key): Promise<string> {
    return new Promise(accept => {
      return accept(sessionStorage.getItem(key));
    });
  }

  public set(key, value): Promise<string> {
    return new Promise(accept => {
      sessionStorage.setItem(key, value);
      return accept(value);
    });
  }

  public remove(key): Promise<string> {
    return new Promise(accept => {
      sessionStorage.removeItem(key);
      return accept();
    });
  }

  public clear(): Promise<any> {
    return new Promise(accept => {
      sessionStorage.clear();
      return accept();
    });
  }
}

export { SessionStorageDriver }
